export default {
  "newPoll": "+ 新建投票",
  "backToList": "‹ 返回列表",
  "pollManagement": "投票管理",
  "createPollsConfigureOptionsAndDesignPagesSignedInUsers": "创建投票页面，设置投票项与页面样式；登录用户可参与投票并查看统计结果。",
  "searchPollName": "搜索投票名称",
  "search": "搜索",
  "noPollDescription": "暂无投票说明",
  "open": "进入",
  "settings": "设置",
  "preview": "浏览",
  "records": "列表",
  "duplicate": "复制",
  "delete": "删除",
  "noPollsYetClickNewPollToCreateOne": "暂无投票，点击右上角新建投票",
  "pollLinkPreview": "投票链接预览",
  "scanTheQrCodeOrCopyTheLinkToOpen": "扫码或复制下方链接访问投票页；手机端需先登录。",
  "copyLink": "复制链接",
  "draft": "草稿",
  "published": "已发布",
  "closed": "已关闭",
  "linkCopied": "链接已复制",
  "couldNotCopyPleaseCopyTheLinkManually": "复制失败，请手动复制链接",
  "untitledPoll": "未命名投票",
  "pollCreated": "投票已创建",
  "deleteAndItsDirectoryPollsWithVotesCannotBeDeleted": "删除“{p0}”及关联名单？已有投票记录的项目不能删除。",
  "deletePoll": "删除投票",
  "deleted": "已删除",
  "enterPollName": "请输入投票名称",
  "basicFields": "基础题型",
  "image": "图片",
  "searchComponent": "搜索组件",
  "commonFields": "常用题库",
  "layoutComponents": "布局组件",
  "text": "文本",
  "backgroundImage": "背景图",
  "results": "结果显示",
  "spacer": "空白组件",
  "dragTheHandleAtTheTopLeftOfAComponent": "拖动画布中组件左上角的图标即可调整上下顺序。投票组件固定保留。",
  "pollPageDesigner": "投票页面装修",
  "backgroundComponent": "背景图组件",
  "dragToRepositionTheBackgroundVertically": "拖动调整背景图上下位置",
  "dragToReorder": "拖动排序",
  "visibilityRule": "显示条件：",
  "fixedVotingComponent": "固定投票组件 ·",
  "cannotBeDeleted": "· 不可删除",
  "singleChoiceVoting": "单选投票",
  "multipleChoiceVoting": "多选投票",
  "multipleChoice": "多选",
  "singleChoice": "单选",
  "imageComponent": "图片组件",
  "uploadAnImageInThePropertiesPanel": "图片组件：请在右侧上传图片",
  "searchByIdOrName": "输入 ID 或姓名查询",
  "votingOptions": "参与选项",
  "totalVoters": "投票总人数",
  "leaderboard": "排行榜",
  "dragHereToDelete": "▱ 拖动到此处删除",
  "componentSettings": "组件设置",
  "fixed": "（固定）",
  "pollTitle": "投票标题",
  "votingMode": "投票方式",
  "allowMultipleSelections": "允许多选",
  "maximumSelections": "最多可选项数",
  "newOption": "新选项",
  "addOption": "＋ 添加选项",
  "theVotingComponentCannotBeDeletedOptionsCannotBeChanged": "投票组件不可删除。已有投票记录后不能修改投票选项。",
  "title": "标题",
  "required": "是否必填",
  "placeholder": "提示文字",
  "descriptionContent": "说明内容",
  "options": "选项",
  "optionName": "选项名称",
  "value": "值",
  "imageUrl": "图片地址",
  "uploadImage": "上传图片",
  "width": "宽度（%）",
  "position": "位置",
  "left": "左对齐",
  "center": "居中",
  "right": "右对齐",
  "cornerRadiusPx": "圆角（px）",
  "textContent": "文字内容",
  "textColor": "文字颜色",
  "fontSizePx": "文字字号（px）",
  "fontWeight": "文字粗细",
  "regular": "常规",
  "bold": "加粗",
  "extraBold": "特粗",
  "textAlignment": "文字位置",
  "leftMarginPx": "左外边距（px）",
  "rightMarginPx": "右外边距（px）",
  "topPaddingPx": "上内边距（px）",
  "bottomPaddingPx": "下内边距（px）",
  "bottomMarginPx": "下外边距（px）",
  "backgroundColor": "背景颜色",
  "backgroundImageUrl": "背景图片地址",
  "uploadBackground": "上传背景图",
  "clearBackground": "清除背景图",
  "heightPx": "高度（px）",
  "opacity": "透明度（%）",
  "topOffsetPx": "距顶（px）",
  "spacerHeightPx": "占位高度（px）",
  "searchTitle": "查询标题",
  "leaderboardLabel": "排行榜标签",
  "numberOfRankings": "显示排名数量",
  "backButtonPosition": "返回按钮位置",
  "topLeft": "左上方",
  "bottomOfPage": "页面下方",
  "displaysOptionAndVoterCountsWithALinkToThe": "该组件展示参与选项数、已投票总人数，并可进入固定样式的排行榜页面。",
  "visibilityRules": "显示条件",
  "none": "无",
  "enabled": "有",
  "sourceField": "依赖字段",
  "selectAVoteRadioDropdownOrCheckboxField": "请选择投票/单选/下拉/多选字段",
  "selectAnOption": "请选择选项",
  "addAVoteRadioDropdownOrCheckboxComponentFirst": "请先在上方添加投票、单选、下拉或多选组件。",
  "selectAComponentFirst": "请先选择一个组件",
  "pageSettings": "页面设置",
  "titleColor": "标题文字颜色",
  "titleFontSizePx": "标题字号（px）",
  "titleAlignment": "标题位置",
  "submitButtonColor": "提交按钮颜色",
  "submitButtonTextColor": "提交按钮文字颜色",
  "submitButtonWidth": "提交按钮宽度（%）",
  "pageBackgroundColor": "页面背景色",
  "enterImageUrl": "输入图片地址",
  "pollSettings": "投票设置",
  "pollName": "投票名称",
  "publicationStatus": "发布状态",
  "startTimeOptional": "开始时间（可选）",
  "noStartTimeLimit": "不限开始时间",
  "endTimeOptional": "结束时间（可选）",
  "noEndTimeLimit": "不限结束时间",
  "allSignedInUsersMayVoteOncePerAccountThe": "所有登录用户均可投票，每个账号只能投一次。搜索组件只用于查询名单资料，不限制投票资格。",
  "wechatSharing": "💬 微信分享",
  "configureTheTitleSubtitleAndCoverForWechatSharingCards": "配置好友会话中转发卡片的标题、副标题与封面。分享标题留空时默认使用投票名称。",
  "shareTitle": "分享标题",
  "optionalDefaultsToThePollName": "可留空，留空则回落为投票名称",
  "subtitle": "副标题",
  "optionalDisplayedBelowTheTitle": "选填，显示在标题下方",
  "shareImage": "分享图",
  "recommended500500PxJpgPngUpTo5Mb": "建议尺寸 500×500px，支持 JPG / PNG，大小不超过 5MB",
  "uploading": "上传中…",
  "uploadShareCover": "上传分享封面",
  "clearShareImage": "清除分享图",
  "save": "保存",
  "publish": "发布",
  "couldNotLoadPoll": "投票加载失败",
  "retry": "重试",
  "edit": "编辑",
  "votingRecords": "投票列表",
  "singleLineText": "单行文本",
  "multilineText": "多行文本",
  "radioButtons": "单选项",
  "dropdown": "下拉选择",
  "checkboxes": "多选项",
  "number": "数字",
  "date": "日期",
  "divider": "分割线",
  "description": "说明文字",
  "name": "姓名",
  "phoneNumber": "手机号",
  "gender": "性别",
  "email": "邮箱",
  "yesNo": "是否",
  "wechatId": "微信号",
  "idNumber": "身份证号",
  "dateOfBirth": "出生年月",
  "address": "地址",
  "votingComponent": "投票组件",
  "component": "组件",
  "chooseAnOption": "请选择您的投票项",
  "for": "赞成",
  "against": "反对",
  "abstain": "弃权",
  "aPageSupportsUpTo50Components": "最多 50 个组件",
  "onlyOneSearchComponentIsAllowedPerPage": "每个页面只能添加一个搜索组件",
  "onlyOneResultsComponentIsAllowedPerPage": "每个页面只能添加一个结果显示组件",
  "enterText": "请输入文字",
  "directorySearch": "名单查询",
  "option": "选项{p0}",
  "pollSaved": "投票已保存",
  "pollPublished": "投票已发布",
  "imagesMustNotExceed5Mb": "图片不能超过 5MB",
  "youHaveUnsavedChangesLeaveThisPage": "有未保存的修改，确定离开？",
  "notice": "提示",
  "searchVoterInformation": "搜索投票人信息",
  "pollOptions": "投票选项",
  "reset": "重置",
  "export": "导出",
  "copyPollLink": "复制投票链接",
  "refresh": "刷新",
  "noVotingRecordsYetVotesFromSignedInUsersWill": "暂无投票记录，登录用户完成投票后将显示在此处",
  "voter": "投票人",
  "selectedOptions": "投票项",
  "votedAt": "投票时间",
  "voted": "已投票",
  "noVotingRecordsMatchTheCurrentFilters": "当前筛选条件下暂无可导出的投票记录",
  "exportedVotingRecords": "已导出 {p0} 条投票记录",
  "couldNotExportVotingRecordsPleaseTryAgainLater": "投票记录导出失败，请稍后重试",
  "requiredColumnsIdAndNameOtherColumnsAreCustomizableAnd": "固定列：ID、姓名。其余列可自定义并展示在搜索结果中。名单不限制投票资格。",
  "noDirectoryUploaded": "尚未上传名单",
  "downloadTemplate": "下载模板",
  "replaceFile": "更换文件",
  "uploadFile": "上传文件",
  "deleteFile": "删除文件",
  "supportsXlsxXlsAndCsvFirstSheetUpTo5": "支持 XLSX、XLS、CSV，首个工作表，最大 5MB / 5000 行。上传与删除立即生效，不删除已有投票记录。",
  "directoryPreview": "名单文件预览",
  "confirmingReplacesTheEntireDirectoryExistingVotesAreUnaffected": "确认后将完整替换原名单文件，已投票记录不受影响。",
  "cancel": "取消",
  "confirmReplacement": "确认替换",
  "confirmUpload": "确认上传",
  "directory": "查询名单",
  "pollDirectoryTemplateXlsx": "投票查询名单模板.xlsx",
  "filesMustNotExceed5Mb": "文件不能超过 5MB",
  "upTo5000RowsAnd30ColumnsPerFile": "每次最多 5000 行、30 列",
  "includeIdAndNameColumnsHeadersMustBeNonEmpty": "必须包含 ID、姓名列，表头不得为空或重复",
  "headersContainReservedNames": "表头包含保留名称",
  "rowMissingOverlongOrDuplicateIdOrInvalidName": "第 {p0} 行 ID 缺失、过长、重复，或姓名无效",
  "rowACellExceeds1000Characters": "第 {p0} 行单元格内容超过 1000 字",
  "noDirectoryEntriesFound": "文件中没有名单数据",
  "couldNotReadTheFile": "文件无法读取",
  "importedDirectoryEntries": "已导入 {p0} 条名单资料",
  "deleteTheCurrentDirectoryAndSearchDataExistingVotesWill": "删除当前名单文件及查询数据？已有投票记录将保留。",
  "deleteDirectory": "删除名单",
  "directoryDeleted": "名单已删除",
  "lastSaved": "最后保存时间：",
  "updated": "更新于",
  "votingOptions2": "共 {p0} 个投票选项",
  "peopleHaveVoted": "已有 {p0} 人投票",
  "entries": "共 {p0} 条资料",
  "rowsColumnsFirst10RowsShown": "{p0} · 共 {p1} 行 / {p2} 列（预览前 10 行）",
  "voters": "人",
  "pollOptions2": "投票选项（{p0}）",
  "resultsComponent": "结果显示组件",
  "enterField": "请输入{label}",
  "validField": "请填写有效的{label}",
  "male": "男",
  "female": "女",
  "other": "其他",
  "yes": "是",
  "no": "否",
  "recordsFilename": "投票记录导出_{stamp}.xlsx",
  "query": "查询",
  "recordSheetName": "投票记录"
}
